const config = {
  SESSION_EXPIRE_TIME: 360, //in minutes
  AUTH_ENDPOINT: process.env.REACT_APP_AUTH_ENDPOINT || "",
  REST_ENDPOINT: process.env.REACT_APP_REST_ENDPOINT || "",
  MAINTENANCE_BYPASS_KEY: process.env.REACT_APP_MAINTENANCE_BYPASS_KEY || "",
};

export default config;
